// This file is auto-generated by scripts/generateApiTypes.ts. Do not edit manually.

export const samOperations = {
  HealthController_health: ['get', '/health'] as const,
  HealthController_healtToken: ['get', '/health/token'] as const,
  ApplicationAccessController_findApplicationAccess: [
    'get',
    '/app/access'
  ] as const,
  ApplicationsController_getApplicationRoles: [
    'get',
    '/applications/{appId}/roles'
  ] as const,
  ApplicationsController_getApplication: [
    'post',
    '/applications/{appId}'
  ] as const,
  ApplicationsController_setAppUsageStats: [
    'post',
    '/applications/{appId}/{userId}/{mobileInd}'
  ] as const,
  NotificationsController_getByAppIdAndUnitCode: [
    'get',
    '/notifications/{appId}/{unitCode}'
  ] as const,
  NotificationsController_getByAppIdUnitCodeAndType: [
    'get',
    '/notifications/{appId}/{unitCode}/{notificationType}'
  ] as const,
  NotificationsController_create: ['post', '/notifications'] as const,
  EmployeeController_findEmployeeByUserId: [
    'get',
    '/employee/{userId}'
  ] as const,
  EmployeeController_findEmployeeFromUsersList: [
    'post',
    '/employee/users'
  ] as const,
  RoleController_getAccessByUserId: [
    'get',
    '/roles/{roleName}/{appId}'
  ] as const,
  RoleController_createRole: ['post', '/roles'] as const,
  UsersController_searchDeereContact: [
    'get',
    '/users/deere/contact/{userId}'
  ] as const,
  UsersController_getAccessByUserId: [
    'get',
    '/users/{userId}/{appId}'
  ] as const,
  UsersController_postAccessByUserIdAndAppIdAndRoles: [
    'post',
    '/users/{userId}/{appId}'
  ] as const,
  UsersController_getAccessByUserIdAndAppIdAndRole: [
    'get',
    '/users/{userId}/{appId}/{userRole}'
  ] as const,
  UsersController_getAccessByAppIdAndUserRoleAndSupplierNumber: [
    'get',
    '/users/access/{appId}/{userRole}/{supplierNumber}'
  ] as const,
  UnitsController_searchDeereContact: ['get', '/units/{appId}/{role}'] as const,
  UnitsController_getUnitsByAppRoleAndUserId: [
    'get',
    '/units/{appId}/{role}/{userId}'
  ] as const,
  UnitsController_getUnitsByRollup: ['get', '/units/{rollup}'] as const,
  UnitController_getUnitsAndSupplierByAppRoleAndUserId: [
    'get',
    '/unit/{appId}/{role}/{userId}'
  ] as const
} as const;
